import React from 'react';
import { Layout as AntLayout } from 'antd';
import styled from 'styled-components';
import { useLocalStorage } from 'hooks';
import Header from './Header/Header';
import Content from './Content';

type Props = {
    guest: boolean;
    children?: React.ReactChild | React.ReactChild[];
};

const StyledLayout = styled(AntLayout)<{ value: string }>`
    overflow-y: auto;
    background-color: ${props => props.theme.background.white};
    padding-left: 4%;
    padding-right: 4%;
`;

const Layout: React.FC<Props> = ({ children, guest }: Props) => {
    const [value] = useLocalStorage('size', '1');

    return (
        <StyledLayout value={value}>
            <Header guest={guest} />
            <Content guest={guest}>{children}</Content>
        </StyledLayout>
    );
};

Layout.defaultProps = {
    children: <></>,
};

export default Layout;
